import { Search, X } from "lucide-react";

// Touch-target-safe (44px+) text input with a magnifier icon and an inline
// clear button. Used by Expense Register and the Nairana/Workshop/Defender
// item registers to filter long lists inline.
export default function SearchInput({
  value,
  onChange,
  placeholder = "Search…",
  ariaLabel = "Search items",
}) {
  return (
    <div className="relative">
      <span
        className="absolute inset-y-0 left-3 flex items-center text-slate-400 pointer-events-none"
        aria-hidden="true"
      >
        <Search size={16} strokeWidth={2} />
      </span>
      <input
        type="search"
        inputMode="search"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
        className="w-full h-11 pl-9 pr-10 text-sm bg-white border border-slate-200 rounded-xl shadow-[0_1px_2px_rgba(15,23,42,0.04)] focus:outline-none focus:ring-2 focus:ring-[#1B3A5C]/30 focus:border-[#1B3A5C]/40 placeholder:text-slate-400"
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange("")}
          aria-label="Clear search"
          className="absolute inset-y-0 right-1 my-auto flex items-center justify-center w-9 h-9 rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors"
        >
          <X size={16} strokeWidth={2.25} />
        </button>
      )}
    </div>
  );
}
